import type { Plugin, SegmentEvent } from '@segment/analytics-next'

const log = (label: string, event: SegmentEvent) => {
  const eventName = event?.event || event?.name || event?.type || 'Unknown event'
  const properties = event?.properties || event?.traits || {}

  console.debug(`%c🕵️ [Segment]: ${label} > ${eventName}`, 'color: #FF8283; font-weight: bold;', {
    event: eventName,
    properties,
    rawEvent: event,
  })
}

/* Segment Logger Plugin for custom Segment debugging */
export const SegmentLogger: Plugin = {
  name: 'Segment Logger',
  type: 'after',
  isLoaded: () => true,
  load: async () => {
    log('Plugin Loaded', { type: 'track', name: 'Segment Logger' })

    return true
  },
  track: (context) => {
    log('Track', context.event)

    return context
  },
  page: (context) => {
    log('Page', context.event)

    return context
  },
  identify: (context) => {
    log('Identify', context.event)

    return context
  },
  group: (context) => {
    log('Group', context.event)

    return context
  },
}
